<template>
	<div
		class="user-coupons user-coupons--collapsed"
	>
		<h3
			class="user-coupons__title"
			v-html="$t('checkout.couponUserTitle')"
		/>
		<div
			class="user-coupons__wrapper"
			ref="wrapper"
		>
			<div
				class="user-coupons__trigger"
        :class="{
          'user-coupons__trigger--disabled': disabled
        }"
				v-html="$t('checkout.couponUserLabel')"
			/>
			<fieldset class="user-coupons__list">
				<div class="user-coupons__list-wrapper">
					<label
						v-for="coupon in coupons"
						:key="coupon.value"
						class="user-coupons__coupon"
					>
						<input
							type="radio"
							class="user-coupons__coupon-input"
							name="user-coupons"
							:value="coupon.code"
							:checked="coupon.active"
							@change="onChange"
						>
						<div class="user-coupons__coupon-wrapper">
							<div class="user-coupons__coupon-info">
								<span
									class="user-coupons__coupon-name"
									v-html="coupon.title"
								/>
								<span
                  v-if="coupon.validUntil"
									class="user-coupons__coupon-expiration"
									v-html="formatDate(coupon.validUntil)"
								/>
								<span
                  v-if="coupon.validity"
									class="user-coupons__coupon-expiration"
									v-html="$t('checkout.couponValidity', { validity: coupon.validity })"
								/>
								<span
									v-if="coupon.exclusive"
									class="user-coupons__coupon-expiration"
									v-html="$t('checkout.couponUserExclusive')"
								/>
							</div>
							<span
								class="user-coupon__value"
								v-html="formatDiscount(coupon.discount)"
							/>
						</div>
					</label>
				</div>
			</fieldset>
		</div>
	</div>
</template>

<script>
import collapsible from '@/app/collapsible';
import leadingZero from '@/utils/leadingZero';

export default {
	props: {
		coupons: Array,
    disabled: Boolean
	},
	data() {
		return {};
	},
	computed: {
		activeCoupon() {
			return this.coupons.find(coupon => coupon.active);
		}
	},
	methods: {
		onChange(e) {
			this.collapsible.close();
			this.$emit('input', e.target.value);
		},
		formatDate(date) {
			let output;

			if (date) {
				const d = new Date(date);
				const day = leadingZero(d.getDate());
				const month = leadingZero(d.getMonth() + 1);
				const year = d.getFullYear();

				output = `${day}.${month}.${year}`;
			}
			else {
				output = '-';
			}

			return this.$t('checkout.couponValidUntil', { date: output });
		},
		formatDiscount(discount) {
			discount = '' + discount;
			if (discount.indexOf('%') < 0) {
				// multiply by 100 because coupon is in francs rather than cents
				discount = this.$options.filters.fwgpricecent(discount * 100, 'html')
			}
			return discount;
		},
		outsideClick(e) {
			if (e.target !== this.$refs.wrapper && !this.$refs.wrapper?.contains(e.target)) {
				this.collapsible.close();
			}
		}
	},
	mounted() {
		this.collapsible = collapsible(this.$el, {
			triggerSelector: '.user-coupons__trigger',
			contentSelector: '.user-coupons__list',
			collapsedClass: 'user-coupons--collapsed',
			// callback,
		});
		document.body.addEventListener('click', this.outsideClick);
	},
	destroy() {
		document.body.removeEventListener('click', this.outsideClick);
	}
}
</script>

<style>

</style>
